module.exports = __webpack_public_path__ + "static/media/logo3D.5ce0cf28.gif";